import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, from, forkJoin } from 'rxjs';

import { BrComService } from '../../service/BrComService';
import { HttpServidor } from '../shared/abstract/http-servidor';

@Injectable()
export class AuthProvider extends HttpServidor {

  constructor(http: HttpClient, private brComService: BrComService) {
    super(http);
  }

  public login(CPF: string, telefone: string, idDevice: number): Observable<any> {
    return new Observable<any>(
      observer => {
        forkJoin(from(this.brComService.obtemImei())).toPromise().then(
          result => {
            const form = new FormData();
            form.append('cpf', CPF);
            form.append('telefone', telefone);
            form.append('imei', result[0]);
            form.append('codAppEmpresa', this.brComService.readAppDomain());
            form.append('idDevice', JSON.stringify(idDevice));
            this.post('procuraUsuario', form).subscribe(
              result => {
                observer.next(result);
              }, error => {
                observer.error(error);
              }, () => {
                observer.complete();
              }
            );
          }
        )
      }
    )
  }

}



// WEBPACK FOOTER //
// ./src/providers/auth/auth.ts